import React, { useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';

function CreateAlertPageStyleLoader({ children }) {
  const { theme } = useTheme();

  useEffect(() => {
    const loadStyles = async () => {
      try {
        if (theme === 'dark') {
          await import('../styles/themes/dark/pages/CreateAlertPage.css');
        } else {
          await import('../styles/themes/light/pages/CreateAlertPage.css');
        }
      } catch (error) {
        console.error('Error loading CreateAlertPage styles:', error);
      }
    };

    loadStyles();
  }, [theme]);

  return <>{children}</>;
}

export default CreateAlertPageStyleLoader;
